import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
//Pages
import {PalestrantesPage} from '../palestrantes/palestrantes';
import {AtividadePage} from '../atividade/atividade';
import { RefreshInfoComponent } from '../../components/refresh-info/refresh-info.component';
//Providers
import { ConfigProvider } from '../../providers/config-provider';
import { UtilProvider } from '../../providers/util-provider';
import { CongressoProvider } from '../../providers/congresso-provider';
import { LecturerProvider } from '../../providers/lecturer-provider';
import { AuthProvider } from '../../providers/auth-provider';
import { StorageProvider } from '../../providers/storage-provider';
//Components
import { CustomAlert } from '../../components/custom-alert.component';
//Models
import { Url } from '../../models/url.model';
import { Lecturer } from '../../models/lecturer.model';
import { User } from '../../models/user.model';
import { Congresso } from '../../models/congresso.model';
import { Activity } from '../../models/activity.model';

@Component({
    selector: 'page-palestrante-perfil',
    templateUrl: 'palestrante-perfil.html'
})
export class PalestrantePerfilPage {
    public palestrante: Lecturer;
    public user: User;
    public congresso: Congresso
    public tema: any;
    public atividades: Array<any>;
    public activities: Array<Activity>
    public convidados: Array<any>;
    public favoritos: Array<any>;
    public secondaryLight: string;
    public loadFirst: boolean;
    public loaded: boolean;
    public isCurrent: boolean;
    public lastRefreshDate: string;
    public dateRef: string;


    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public alert: CustomAlert,
        public utilProvider: UtilProvider,
        public configProvider: ConfigProvider,
        public auth: AuthProvider,
        private storageProvider: StorageProvider,
        public palestrantesProvider: LecturerProvider) {

        this.palestrante = this.navParams.get("palestrante");
        if (!this.palestrante) {
            let sgunId = this.navParams.get("id");
            let palestrantes = JSON.parse(localStorage.getItem("palestrantes")) as Array<Lecturer>;
            this.palestrante = palestrantes.filter(x => x.SgunId == sgunId)[0] as Lecturer;
        }
        this.user = JSON.parse(localStorage.getItem("user")) as User;
        this.congresso = JSON.parse(localStorage.getItem("congresso")) as Congresso;
        this.convidados = new Array<any>();
        this.secondaryLight = this.utilProvider.lightenDarkenColor(this.congresso.CorSecundaria, 15.9);
        this.loaded = false;
        this.isCurrent = this.congresso.Ano == configProvider.ANO_ATUAL || this.congresso.Liberado; 
        this.atividades = new Array<any>();
        let days = localStorage.getItem('atividadesDia') ? JSON.parse(localStorage.getItem('atividadesDia')) : JSON.parse(localStorage.getItem('programacaoAtual')) ;
        this.activities = new Array<Activity>();
        if (days && days.length) {
            days.forEach(x => {
                Array.prototype.push.apply(this.activities, x.Atividades);
            });
        }

        this.lastRefreshDate = this.storageProvider.get('lastRefreshDate');
        this.dateRef = this.utilProvider.formaRefreshDate(this.lastRefreshDate);
        this.loaded = false;
    }

    ionViewDidEnter() {
        this.utilProvider.searchInFocus = false;
        this.favoritos = localStorage.getItem("palestrantesFavoritos") ? JSON.parse(localStorage.getItem("palestrantesFavoritos")) : new Array<any>();

    }

    ionViewDidLoad() {
        this.getActivities();
    }

    getActivities() {
        let self = this;
        let user = self.user ? self.user : new User();
        let con = self.utilProvider.isConnected(false)

        if (con) {
            setTimeout(() => {
                this.palestrantesProvider.getAtividades(self.congresso.Ano, user.Guid, self.palestrante.SgunId)
                    .then(res => {

                        self.atividades = res;
                        self.convidados = res.map((a) => (a.Palestrantes)).filter(p => p.Tipo != 'Palestrante');
                        self.tema = res.filter(a => a.IsTema);
                        self.atividades.pop();
                        self.loaded = true;
                    })
                    .catch(response => {
                        let err = response;
                        self.loaded = true;
                        if (err) {

                          self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
                        }
                    });
            }, 0);
        }
        else {
            let ativs = self.activities.filter((a) => a.AtividadesCadastro.filter(c => c.Palestrantes.length > 0 &&
                this.utilProvider.prepareSearch(c.Palestrantes[0].Nomes.toLowerCase()).indexOf(this.utilProvider.prepareSearch(self.palestrante.Nome.toLowerCase())) > -1).length > 0);

            let cadastros = ativs.map((a) => (a.AtividadesCadastro));
            self.atividades = cadastros[0];
            self.convidados = self.atividades.map((a) => (a.Palestrantes)).filter(p => p && p.Tipo != 'Palestrante');
            self.tema = self.atividades.filter(a => a.IsTema);
            if (!self.tema.length) {
                self.tema[0] = self.atividades[0];
                self.tema[0].NomeAtividade = ativs.filter(x => x.AtividadeId == self.tema[0].AtividadeId)[0].TemaDaAtividade;
            }
            //self.atividades.pop();
            self.loaded = true;
        }
    }

    getTema(id) {
        return this.tema.filter(x => x.AtividadeId == id)[0];
    }


    addFavorite() {
        let self = this;
        if (this.isCurrent && this.auth.isAuthorized()) {
          if(self.utilProvider.isConnected(true)){
            self.utilProvider.loadingShow();
            self.palestrantesProvider.adicionarPalestranteFavorito(this.user.Guid, this.palestrante.SgunId.toString())
                .then(res => {
                    self.utilProvider.loadingHide();
                    self.palestrante.IsFavorito = true;
                    self.favoritos.push({ Id: self.palestrante.Id, GuidSgun: '', PalestranteSgunId: self.palestrante.SgunId });
                    localStorage.setItem('palestrantesFavoritos', JSON.stringify(self.favoritos));
                    self.alert.showAlert('Sucesso', 'Palestrante adicionado!');
                })
                .catch(response => {
                    let err = response;
                    if (err) {
                        self.utilProvider.loadingHide();

                        self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
                    }
                });
              }
        }
    }

    removeFavorite() {
        let self = this;
        if (this.isCurrent && this.auth.isAuthorized()) {
            if(self.utilProvider.isConnected(true)){
            self.utilProvider.loadingShow();
            self.palestrantesProvider.removerPalestranteFavorito(this.user.Guid, this.palestrante.SgunId)
                .then(res => {

                    self.favoritos = self.favoritos.filter(x => x.PalestranteSgunId != self.palestrante.SgunId);
                    localStorage.setItem('palestrantesFavoritos', JSON.stringify(self.favoritos));
                    self.alert.showAlert('Sucesso', 'Palestrante removido.');
                    self.palestrante.IsFavorito = false;
                    self.utilProvider.loadingHide();
                })
                .catch(response => {
                    let err = response;
                    if (err) {
                        self.utilProvider.loadingHide();

                        self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
                    }
                });
              }
        }
    }

    openInscriptionPage(activityId: number) {

        this.navCtrl.push(AtividadePage, {
            id: activityId,
        });

    }

    back() {
        this.navCtrl.pop();
    }

    isFavorite(p: Lecturer) {
        return p.IsFavorito || (this.favoritos && this.favoritos.some(x => x.PalestranteSgunId == p.SgunId));
    }

    setLoadFirst(a: any, i): boolean {

        if (!a)
            return false;

        let ret = !a.Palestrantes || !a.Palestrantes.length && !a.IsTema && (this.atividades[i + 1] && this.atividades[i + 1].Palestrantes[0] && this.atividades[i + 1].Palestrantes[0].Nomes.indexOf(this.palestrante.Nome) != -1);
        return ret;
    }

    setLoadSecond(a: any, i): boolean {

        if (!a)
            return false;

        let ret = (!this.loadFirst && this.convidados) && (a.Palestrantes && a.Palestrantes.length && this.convidados[i][0].Nomes.toLowerCase().indexOf(this.palestrante.Nome.toLowerCase()) != -1)
        return ret;
    }
}



// WEBPACK FOOTER //
// ./src/pages/palestrante-perfil/palestrante-perfil.ts